//
//
// header - scroll button
$('.scrollBtn').on('click', function(event) {
    event.preventDefault();
    goToSection__scroll('#cervejas');
});